import { AdsPlatform } from '@/interface/order';
import PromotionalLinkCopy from './PromotionalLinkCopy';

export const getContents = (platform: AdsPlatform, utmLink: string, t: any) => {
  if (platform === AdsPlatform.Youtube) {
    return [
      {
        title: (
          <div className="self-stretch justify-start">
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.add')}
            </span>
            <PromotionalLinkCopy utmLink={utmLink} />
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.atTheBeginning')}{' '}
            </span>
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.beginningOfVideoDescription')}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.makingSureVisible')}
            </span>
          </div>
        ),
        width: 504,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-youtube-1.png`
      },
      {
        title: (
          <div className="self-stretch inline-flex flex-col justify-start items-start gap-3">
            <div className="w-full justify-start text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNotUseOfficialWebsite')}
            </div>
          </div>
        ),
        width: 504,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-youtube-3.png`
      },
      {
        title: (
          <div className="w-full justify-start text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
            {t('ModalPromotionalLinkEducation.doNotPlaceThirdLine')}
          </div>
        ),
        width: 504,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-youtube-2.png`
      }
    ];
  }
  if (platform === AdsPlatform.TikTok) {
    return [
      {
        title: (
          <div className="self-stretch justify-start">
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.add')}
            </span>
            <PromotionalLinkCopy utmLink={utmLink} />
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.inYour')}{' '}
            </span>
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.linkInBio')}{' '}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.linktreeInstructions')}
            </span>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-tiktok-1.png`
      },
      {
        title: (
          <div className="w-[560px] justify-start">
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNot')}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {' '}
              {t('ModalPromotionalLinkEducation.addInVideoDescription')}
            </span>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-tiktok-2.png`
      },
      {
        title: (
          <div className="w-[560px] justify-start">
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNot')}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {' '}
              {t('ModalPromotionalLinkEducation.useOfficialWebsite')}
            </span>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-tiktok-3.png`
      },
      {
        title: (
          <div className="w-[560px] justify-start">
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNot')}{' '}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.addToProfileDescription')}
            </span>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-tiktok-4.png`
      }
    ];
  }
  if (platform === AdsPlatform.Instagram) {
    return [
      {
        title: (
          <div className="self-stretch relative inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch justify-start">
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.add')}
              </span>
              <PromotionalLinkCopy utmLink={utmLink} />
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.inYour')}{' '}
              </span>
              <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.linkInBio')}{' '}
              </span>
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.linktreeInstructions')}
              </span>
            </div>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-instagram-1.png`
      },
      {
        title: (
          <div className="w-[560px] justify-start">
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNot')}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {' '}
              {t('ModalPromotionalLinkEducation.addInVideoDescription')}
            </span>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-instagram-2.png`
      },
      {
        title: (
          <div className="justify-start">
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNot')}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {' '}
              {t('ModalPromotionalLinkEducation.useOfficialWebsite')}
            </span>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-instagram-3.png`
      },
      {
        title: (
          <div className="justify-start">
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNot')}{' '}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.addToProfileDescription')}
            </span>
          </div>
        ),
        width: 318,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-instagram-4.png`
      }
    ];
  }
  if (platform === AdsPlatform.LinkedIn) {
    return [
      {
        title: (
          <div className="self-stretch relative inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch justify-start">
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.add')}
              </span>
              <PromotionalLinkCopy utmLink={utmLink} />
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.inYour')}{' '}
              </span>
              <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.postCaption')}
              </span>
            </div>
          </div>
        ),
        width: 504,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-linkedin-1.png`
      },
      {
        title: (
          <div className="self-stretch justify-start">
            <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
              {t('ModalPromotionalLinkEducation.doNot')}
            </span>
            <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
              {' '}
              {t('ModalPromotionalLinkEducation.useOfficialWebsite')}
            </span>
          </div>
        ),
        width: 504,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-linkedin-2.png`
      }
    ];
  }
  if (platform === AdsPlatform.Twitter) {
    return [
      {
        title: (
          <div className="self-stretch relative inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch justify-start">
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.add')}
              </span>
              <PromotionalLinkCopy utmLink={utmLink} />
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.inYour')}{' '}
              </span>
              <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.postCaption')}
              </span>
            </div>
          </div>
        ),
        width: 504,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-twitter-1.png`
      },
      {
        title: (
          <div className="self-stretch inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch justify-start">
              <span className="text-[#1C2024] text-sm font-[600] font-['Inter'] leading-snug">
                {t('ModalPromotionalLinkEducation.doNot')}
              </span>
              <span className="text-[#1C2024] text-sm font-normal font-['Inter'] leading-snug">
                {' '}
                {t('ModalPromotionalLinkEducation.useOfficialWebsite')}
              </span>
            </div>
          </div>
        ),
        width: 504,
        img: `https://website-resource.ahaglobal.io/ads-platform/promotional-link/promotionnal-link-modal-twitter-2.png`
      }
    ];
  }

  return [];
};
